module.exports = __webpack_public_path__ + "0a64a4a3bc1e623d9ea5203b2f0fc022.svg";